/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewMenuItemModifierDto as DigiworkMaitreDPosDtoMenuItemModifiersNewMenuItemModifierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItemModifiers/new-menu-item-modifier-dto';
import { MenuItemDto as DigiworkMaitreDPosDtoMenuItemsMenuItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';

export interface UpdateMenuItem_1$Params {
  menuItemId: string;
      body?: {
'Name'?: string;
'ImageFile'?: Blob;
'MenuCategoryId'?: string;
'MenuSubcategoryId'?: string;
'Price'?: number;
'TaxRateId'?: string;
'ItemIngredients'?: string;
'ItemModifiers'?: Array<DigiworkMaitreDPosDtoMenuItemModifiersNewMenuItemModifierDto>;
}
}

export function updateMenuItem_1(http: HttpClient, rootUrl: string, params: UpdateMenuItem_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>> {
  const rb = new RequestBuilder(rootUrl, updateMenuItem_1.PATH, 'put');
  if (params) {
    rb.path('menuItemId', params.menuItemId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemDto>;
    })
  );
}

updateMenuItem_1.PATH = '/api/menu-categories/menu-items/{menuItemId}';
